"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importStar(require("react"));
const EmailCanvasUpgradeTemplate_1 = require("./EmailCanvasUpgradeTemplate");
const reactstrap_1 = require("reactstrap");
const react_router_dom_1 = require("react-router-dom");
const draftjs_to_html_1 = tslib_1.__importDefault(require("draftjs-to-html"));
const hooks_1 = require("../../hooks");
exports.EmailCanvasTemplateView = () => {
    const { state: { draftEmail: draft }, } = hooks_1.useEmailCanvasContext();
    const releaseNotesHTML = react_2.useMemo(() => {
        try {
            return draftjs_to_html_1.default(JSON.parse(draft.emailTemplateVersion.releaseNotes));
        }
        catch (e) {
            console.warn('Invalid releaseNotes: ', e);
            return '<p>There was an error loading release notes. They may not have been saved properly.</p>';
        }
    }, [draft.emailTemplateVersion.releaseNotes]);
    return (react_2.default.createElement(react_1.OsmosysSmallContainer, { osysName: "EmailCanvasTemplateView" },
        react_2.default.createElement(react_1.OsmosysDiv, { osysName: "EmailCanvasTemplateView.inner", flexCol: true },
            react_2.default.createElement(reactstrap_1.Card, { body: true, className: "text-left" },
                react_2.default.createElement("h3", null, "Current template"),
                react_2.default.createElement("p", { className: "lead mb-1" },
                    react_2.default.createElement(react_router_dom_1.Link, { target: "_blank", to: `/templates/${draft.emailTemplateVersion.template.id}` }, draft.emailTemplateVersion.template.name)),
                react_2.default.createElement("p", { className: "text-muted" },
                    react_2.default.createElement(react_router_dom_1.Link, { target: "_blank", className: "text-reset", to: `/templates/${draft.emailTemplateVersion.template.id}/versions/${draft.emailTemplateVersion.id}` },
                        "Version ",
                        draft.emailTemplateVersion.version)),
                react_2.default.createElement("div", { className: "small text-muted", dangerouslySetInnerHTML: { __html: releaseNotesHTML } }),
                react_2.default.createElement("div", null,
                    react_2.default.createElement(react_1.OsmosysButton, { osysName: "EmailCanvasTemplateView.Button", to: `/templates/${draft.emailTemplateVersion.template.id}/versions/${draft.emailTemplateVersion.id}`, openInNewTab: true, osysIcon: "externalLink", iconPosition: "right", className: "text-center", size: "sm" }, "Open")),
                react_2.default.createElement("div", { className: "small text-muted" }, "\u00A0"),
                react_2.default.createElement("div", { className: "small text-muted" }, "TIP: If you do not see the production template you wish to upgrade to, refresh your browser window."),
                react_2.default.createElement(EmailCanvasUpgradeTemplate_1.EmailCanvasUpgradeTemplate, null)))));
};
//# sourceMappingURL=index.js.map